import React from 'react';
import Icons from 'lib/components/Icons';
import { combineClassNames, titleize } from 'lib/utility';

const CardHeaderTitleAlert = ({ className, alert, type = 'warning' }) => {
  const Icon = Icons[titleize(type)];

  return (
    <span className={combineClassNames(['box__header__title__alert', `box__header__title__alert--${type}`], className)}>
      <span className="box__header__title__alert__icon">
        <Icon />
      </span>
      {alert}
    </span>
  );
};

export default CardHeaderTitleAlert;
